require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./flexlayout"), require("./label"), require("./list"), require("./collapse"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./flexlayout", "./label", "./list", "./collapse"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./flexlayout"), require("./label"), require("./list"), require("./collapse")) : factory(root["./utils"], root["./flexlayout"], root["./label"], root["./list"], root["./collapse"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__19__, __WEBPACK_EXTERNAL_MODULE__25__, __WEBPACK_EXTERNAL_MODULE__42__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[36],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__19__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__25__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = require("react-measure");

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(333);


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ListDropdown = _interopRequireDefault(__webpack_require__(334));

exports["default"] = _ListDropdown["default"];
exports.ListDropdown = _ListDropdown["default"];

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactMeasure = _interopRequireDefault(__webpack_require__(32));

var _utils = __webpack_require__(4);

var _collapse = _interopRequireDefault(__webpack_require__(42));

var _list = _interopRequireWildcard(__webpack_require__(25));

var _flexlayout = __webpack_require__(16);

var _label = _interopRequireDefault(__webpack_require__(19));

var _listDropdownHelperFunctions = _interopRequireDefault(__webpack_require__(335));

var _ListDropdown = _interopRequireDefault(__webpack_require__(336));

var _Label = _interopRequireDefault(__webpack_require__(66));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var dropdownClassName = _ListDropdown["default"].dropdownClassName.replace(/"/g, '');

var labelClassName = (0, _utils.classnames)(_Label["default"].labelClassName.replace(/"/g, ''));
var refListPointer = null; // Utils

var cssSize = _utils.cssUtils.cssSize;
var IE11 = _utils.domUtils.IE11,
    getTransformedParentElement = _utils.domUtils.getTransformedParentElement;
var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize;

var ListDropdown = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ListDropdown, _Component);

  function ListDropdown(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollHandler", function (e) {
      var onScrollClose = _this.props.onScrollClose;

      if (_this._list && _this._list._node !== e.target && e.target.contains(_this._list._node)) {
        _this.setState({
          scrolled: true
        }, function () {
          onScrollClose && onScrollClose();

          _this.setState({
            scrolled: false
          });
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMenuWidthChange", function (dimensions) {
      var _this$props = _this.props,
          customWidth = _this$props.customWidth,
          open = _this$props.open;

      if (!customWidth && _this._menuNode && open) {
        var menuStyle = _this.state.menuStyle;

        if (menuStyle) {
          if (dimensions.width > menuStyle.minWidth) {
            _this.setState({
              menuStyle: (0, _extends2["default"])({}, menuStyle, {
                minWidth: dimensions.width
              })
            });
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_menuItemRenderer", function (i, props) {
      var _this$props2 = _this.props,
          options = _this$props2.options,
          grouped = _this$props2.grouped,
          listItemContentRenderer = _this$props2.listItemContentRenderer;
      var groupName;

      if (grouped && _this.currentGroup !== options[i].group) {
        groupName = /*#__PURE__*/_react["default"].createElement(_label["default"], {
          className: dropdownClassName + "__groupLabel",
          label: options[i].group,
          type: "caption"
        });
      }

      _this.currentGroup = i !== options.length - 1 ? options[i].group : null;
      var _options$i = options[i],
          icon = _options$i.icon,
          onIconClick = _options$i.onIconClick,
          others = (0, _objectWithoutPropertiesLoose2["default"])(_options$i, ["icon", "onIconClick"]); // NOTE: This might be changed if the structure of grouped select options are changed

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: i
      }, groupName, /*#__PURE__*/_react["default"].createElement(_list.ListItem, (0, _extends2["default"])({
        "data-tid": "ba-common-list-dropdown__listItem-" + i
      }, props, sanitize(others, null, 'label', 'group', 'value', 'title'), {
        icon: icon,
        onIconClick: onIconClick,
        className: dropdownClassName + "__menuItem",
        id: _this._optionId(i)
      }), listItemContentRenderer(props, _this.props)));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onActiveChange", function (_ref) {
      var index = _ref.index;
      var onActiveChange = _this.props.onActiveChange;

      _this.setState({
        focusIndex: index
      });

      onActiveChange && onActiveChange(index);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSelectionChange", function (_ref2) {
      var index = _ref2.index;
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          options = _this$props3.options,
          name = _this$props3.name;
      onChange && onChange(options[index].value, name, index);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isSelected", function (index) {
      return _this.props.selectedIndex === index;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_menuNodeRef", function (node) {
      _this._menuNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_listRef", function (node) {
      _this._list = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_wrapperRef", function (node) {
      _this._wrapper = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_triggerRef", function (node) {
      _this._triggerNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onCollapseMouseDown", function (e) {
      // prevent input from loosing the focus at mousedown phase (prevent blur event)
      // event order: mousedown => blur => mouseup => click
      e.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onCollapseMouseUp", function (e) {
      // if clicking/dragging on the scrollbar, not collapse the dropdown,
      // otherwise manually update the state and loose the focus of input at mouseup phase
      if (_this._list._node !== e.target && e.target !== e.currentTarget) {
        _this._triggerNode.blur();

        _this.props.onClose();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setFocus", function (label) {
      refListPointer[label].current.focus();
    });
    _this.currentGroup = null;
    _this.state = {
      above: false,
      menuStyle: {},
      scrolled: false,
      focusIndex: _props.selectedIndex
    };
    _this.listId = _this.props.triggerNodeId || uniqueId('__selectList'); // Create a map for refs on all dropdown options

    _this.optionsRef = {};

    _props.options.forEach(function (option) {
      _this.optionsRef[option.label] = _react["default"].createRef();
    });

    refListPointer = _this.optionsRef;
    return _this;
  }

  var _proto = ListDropdown.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props4 = this.props,
        wrapperClickListener = _this$props4.wrapperClickListener,
        onClose = _this$props4.onClose;
    document.addEventListener('scroll', this.scrollHandler, true);
    window.addEventListener('resize', onClose);
    wrapperClickListener && this._wrapper.addEventListener('click', wrapperClickListener);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextOpen = nextProps.open,
        nextFocusIndex = nextProps.focusIndex,
        selectedIndex = nextProps.selectedIndex,
        nextClose = nextProps.onClose;
    var _this$props5 = this.props,
        curOpen = _this$props5.open,
        curFocusIndex = _this$props5.focusIndex,
        onClose = _this$props5.onClose;

    if (curOpen && nextOpen && curFocusIndex !== nextFocusIndex) {
      this.setState({
        focusIndex: nextFocusIndex
      });
      this._list && this._list.scrollAround(nextFocusIndex);
    } else if (!curOpen && nextOpen) {
      this.setState({
        focusIndex: selectedIndex
      });
      this._list && this._hasScrolling() && this._list.scrollAround(selectedIndex);
    }

    if (onClose !== nextClose) {
      window.removeEventListener('resize', onClose);
      window.addEventListener('resize', nextClose);
    }

    this._computeMenuState(nextProps);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var focusIndex = this.state.focusIndex;
    var _this$props6 = this.props,
        open = _this$props6.open,
        grouped = _this$props6.grouped; // This is responsible for scrolling the list to the correct point, when the first item in a group is selected
    // Click the first item in a group in a grouped dropdown, and observe the list scrolls to show the group label first

    if (grouped && open && open !== prevProps.open && focusIndex >= 0) {
      // this._list.scrollTo(focusIndex);
      var currentItem = this._list._getItemNode(focusIndex);

      if (currentItem && currentItem.childElementCount > 1) {
        // if this is the first item in its group, scrollup to show the group name as well
        var groupLabel = currentItem.querySelector("." + labelClassName);
        var groupLabelOffset = window.getComputedStyle(groupLabel).marginTop;
        this._list._node.scrollTop = this._list._node.scrollTop - parseInt(groupLabelOffset, 10);
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$props7 = this.props,
        wrapperClickListener = _this$props7.wrapperClickListener,
        onClose = _this$props7.onClose;
    document.removeEventListener('scroll', this.scrollHandler, true);
    window.removeEventListener('resize', onClose);
    wrapperClickListener && this._wrapper.removeEventListener('click', wrapperClickListener);
  };

  _proto._computeMenuState = function _computeMenuState(props) {
    var truncated = props.truncated;
    var _wrapper = this._wrapper,
        _triggerNode = this._triggerNode;
    var newState = {};
    var nb = _triggerNode ? _triggerNode.getBoundingClientRect() : _wrapper.getBoundingClientRect();

    var listHeight = this._getListHeight();

    var style = {
      minWidth: _triggerNode ? _triggerNode.offsetWidth : _wrapper.offsetWidth,
      maxWidth: truncated && _triggerNode ? _triggerNode.offsetWidth : window.innerWidth - nb.left
    };
    var nearestTransform = !IE11 && getTransformedParentElement(_wrapper);
    var targetHeight = nearestTransform ? nearestTransform.getBoundingClientRect().height : window.innerHeight;
    var availableRoomBottom = window.innerHeight - nb.top - nb.height;
    var availableRoomTop = nb.top; // open down if the list can fit opening down or if the list cannot fit opening up and there's more room at the bottom

    if (availableRoomBottom < listHeight && availableRoomTop > availableRoomBottom) {
      var specs = (0, _listDropdownHelperFunctions["default"])(_triggerNode, _wrapper, 'top');
      style.bottom = targetHeight - specs.top - nb.height;
      style.borderBottom = 'none';
      style.left = specs.left;
      newState.above = true;
    } else {
      var _specs = (0, _listDropdownHelperFunctions["default"])(_triggerNode, _wrapper, 'bottom');

      style.top = _specs.top;
      style.borderTop = 'none';
      style.left = _specs.left;
      newState.above = false;
    }

    newState.menuStyle = style;
    this.setState(newState);
  };

  _proto._getNumGroup = function _getNumGroup() {
    var _this$props8 = this.props,
        options = _this$props8.options,
        grouped = _this$props8.grouped;
    var numGroup = 0;

    if (grouped && options.length >= 1) {
      var groupHeader = [options[0].group];
      options.forEach(function (option) {
        if (option.group !== groupHeader[groupHeader.length - 1]) {
          groupHeader.push(option.group);
        }
      });
      numGroup = groupHeader.length;
    }

    return numGroup;
  };

  _proto._getListHeight = function _getListHeight() {
    var _this$props9 = this.props,
        size = _this$props9.size,
        options = _this$props9.options,
        showAllList = _this$props9.showAllList;
    var optionHeight = cssSize(size === 'small' ? 4 : 5);
    var optionsTotalHeight = optionHeight * options.length;

    var groupHeaderHeight = cssSize(4) * this._getNumGroup();

    if (showAllList) {
      return groupHeaderHeight + optionsTotalHeight;
    }

    return Math.min(optionHeight * 5, groupHeaderHeight + optionsTotalHeight);
  };

  _proto._hasScrolling = function _hasScrolling() {
    var _this$props10 = this.props,
        size = _this$props10.size,
        options = _this$props10.options,
        showAllList = _this$props10.showAllList;
    var optionHeight = cssSize(size === 'small' ? 4 : 5);
    var optionsTotalHeight = optionHeight * options.length;

    var groupHeaderHeight = cssSize(4) * this._getNumGroup();

    var defaultHeight = optionHeight * 5;
    return !!(!showAllList && defaultHeight < groupHeaderHeight + optionsTotalHeight);
  } // update the min width of the menu based on the current width of the menu such that as the user
  // scrolls and new menu items are drawn, the menu will never become smaller and only grow in width
  // TODO we actually need to know when the list width changes. Use Measure to detect width changes.
  ;

  _proto._optionId = function _optionId(index) {
    return this.listId + "_" + index;
  };

  _proto.render = function render() {
    var _cx;

    var _this$props11 = this.props,
        id = _this$props11.id,
        truncated = _this$props11.truncated,
        textDir = _this$props11.textDir,
        open = _this$props11.open,
        options = _this$props11.options,
        grouped = _this$props11.grouped,
        size = _this$props11.size,
        triggerNodeRenderer = _this$props11.triggerNodeRenderer,
        className = _this$props11.className,
        customWidth = _this$props11.customWidth,
        onKeyUp = _this$props11.onKeyUp,
        onKeyDown = _this$props11.onKeyDown,
        dropdownFooterRenderer = _this$props11.dropdownFooterRenderer,
        dropdownHeaderRenderer = _this$props11.dropdownHeaderRenderer,
        style = _this$props11.style,
        ariaLabel = _this$props11.ariaLabel,
        virtualized = _this$props11.virtualized,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props11, ["id", "truncated", "textDir", "open", "options", "grouped", "size", "triggerNodeRenderer", "className", "customWidth", "onKeyUp", "onKeyDown", "dropdownFooterRenderer", "dropdownHeaderRenderer", "style", "ariaLabel", "virtualized"]);
    var _this$state = this.state,
        above = _this$state.above,
        menuStyle = _this$state.menuStyle,
        focusIndex = _this$state.focusIndex,
        scrolled = _this$state.scrolled;
    var selectionProps = {
      selectionMode: 'single',
      isSelected: this._isSelected,
      onSelectionChange: this._onSelectionChange
    };
    var wrapperProps = (0, _extends2["default"])({}, sanitize(others, ListDropdown), {
      id: id,
      className: dropdownClassName + "__wrapper " + className,
      style: {
        width: customWidth
      },
      onKeyUp: onKeyUp,
      onKeyDown: onKeyDown,
      ref: this._wrapperRef,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    });
    var collapseProps = {
      className: (0, _utils.classnames)(dropdownClassName, (_cx = {
        truncated: truncated,
        above: above,
        grouped: grouped
      }, _cx[size] = size, _cx)),
      isOpened: !!open,
      style: (0, _extends2["default"])({}, menuStyle, style),
      ref: this._menuNodeRef,
      autoUnmount: true,
      onMouseDown: this._onCollapseMouseDown,
      onMouseUp: this._onCollapseMouseUp,
      'aria-label': ariaLabel
    };
    var measureProps = {
      onResize: this._onMenuWidthChange
    };
    var listContainerProps = {
      style: {
        height: this._getListHeight()
      }
    };
    var listProps = (0, _extends2["default"])({
      id: this.listId,
      tabIndex: -1,
      length: options.length,
      itemRenderer: this._menuItemRenderer,
      initialIndex: focusIndex,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      overflowX: IE11 ? 'hidden' : null,
      onActiveChange: this._onActiveChange,
      activeIndex: focusIndex,
      alwaysDisplayActive: true,
      ref: this._listRef,
      textDir: textDir,
      virtualized: virtualized
    }, selectionProps);

    var dropdownContent = /*#__PURE__*/_react["default"].createElement(_collapse["default"], collapseProps, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, dropdownHeaderRenderer && dropdownHeaderRenderer(), /*#__PURE__*/_react["default"].createElement(_reactMeasure["default"], measureProps, function (_ref3) {
      var measureRef = _ref3.measureRef;
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        ref: measureRef
      }, listContainerProps), /*#__PURE__*/_react["default"].createElement(_list["default"], listProps));
    }), dropdownFooterRenderer && dropdownFooterRenderer()));

    return /*#__PURE__*/_react["default"].createElement("div", wrapperProps, triggerNodeRenderer(this._triggerRef), !scrolled && dropdownContent);
  };

  return ListDropdown;
}(_react.Component);

exports["default"] = ListDropdown;
(0, _defineProperty2["default"])(ListDropdown, "propTypes", {
  id: _propTypes["default"].string,
  triggerNodeId: _propTypes["default"].string,
  truncated: _propTypes["default"].bool,
  menuStyle: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  customWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  size: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    group: _propTypes["default"].any,
    value: _propTypes["default"].any.isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired,
  grouped: _propTypes["default"].bool,
  showAllList: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onScrollClose: _propTypes["default"].func,
  name: _propTypes["default"].string,
  selectedIndex: _propTypes["default"].number,
  focusIndex: _propTypes["default"].number,
  onActiveChange: _propTypes["default"].func,
  wrapperClickListener: _propTypes["default"].func,
  triggerNodeRenderer: _propTypes["default"].func.isRequired,
  listItemContentRenderer: _propTypes["default"].func,
  className: _propTypes["default"].string,
  onKeyUp: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  dropdownHeaderRenderer: _propTypes["default"].func,
  dropdownFooterRenderer: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  style: _propTypes["default"].object,
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  ariaLabel: _propTypes["default"].string,
  virtualized: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(ListDropdown, "defaultProps", {
  grouped: false,
  truncated: true,
  selectedIndex: -1,
  open: false,
  className: '',
  listItemContentRenderer: function listItemContentRenderer(props, thisProps) {
    var options = thisProps.options,
        truncated = thisProps.truncated,
        textDir = thisProps.textDir;
    var _options$props$index = options[props.index],
        label = _options$props$index.label,
        title = _options$props$index.title;
    return /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
      shrink: true,
      grow: true,
      ref: refListPointer[label],
      basis: "auto",
      className: dropdownClassName + "__menuItemInner"
    }, /*#__PURE__*/_react["default"].createElement(_label["default"], {
      ellipsis: truncated,
      label: label || '',
      textDir: textDir,
      truncatedTextExtraOptions: {
        title: title
      }
    }));
  }
});

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getResultSpecs = getResultSpecs;
exports.getValidPlacement = getValidPlacement;
exports["default"] = getSpecs;

var _utils = __webpack_require__(4);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var IE11 = _utils.domUtils.IE11,
    getTransformedParentElement = _utils.domUtils.getTransformedParentElement; // Checks if all placements have been tried

function areRemainingPlacements(placementHistory) {
  if (placementHistory.indexOf('top') >= 0 && placementHistory.indexOf('bottom') >= 0 && placementHistory.indexOf('left') >= 0 && placementHistory.indexOf('right') >= 0) {
    return false;
  }

  return true;
}

function getStartingOffset(triggerRectOffset, nearestRectOffset, scroll, positionedElement) {
  return triggerRectOffset - nearestRectOffset - (positionedElement ? 0 : scroll);
}

var invalidSpecs = {
  top: 0,
  left: 0,
  placement: 'right',
  invalid: true
}; // Returns the actual result specs to use once placement is determined for sure

function getResultSpecs(placement, listDropdownTrigger, triggerRect, containerRect, scrollTop, scrollLeft, options) {
  var resultTop;
  var resultLeft;
  var arrowRect;
  if (options.arrow) arrowRect = options.arrow.getBoundingClientRect();
  var nearestPositionedElement = !IE11 && getTransformedParentElement(listDropdownTrigger);
  var nearestRect = (nearestPositionedElement || document.body).getBoundingClientRect();

  switch (placement) {
    case 'top':
      resultTop = getStartingOffset(triggerRect.top, nearestRect.top, scrollTop, nearestPositionedElement) - containerRect.height;
      resultLeft = getStartingOffset(triggerRect.left, nearestRect.left, scrollLeft, nearestPositionedElement) + triggerRect.width;
      resultLeft -= triggerRect.width;
      if (arrowRect) resultTop -= arrowRect.height < arrowRect.width ? arrowRect.height : arrowRect.width;
      if (typeof options.offset !== 'undefined') resultTop -= options.offset;
      break;

    case 'bottom':
      resultTop = getStartingOffset(triggerRect.top, nearestRect.top, scrollTop, nearestPositionedElement) + triggerRect.height;
      resultLeft = getStartingOffset(triggerRect.left, nearestRect.left, scrollLeft, nearestPositionedElement) + triggerRect.width;
      resultLeft -= triggerRect.width;
      if (arrowRect) resultTop += arrowRect.height < arrowRect.width ? arrowRect.height : arrowRect.width;
      if (typeof options.offset !== 'undefined') resultTop += options.offset;
      break;

    case 'left':
      resultTop = getStartingOffset(triggerRect.top, nearestRect.top, scrollTop, nearestPositionedElement);
      resultLeft = getStartingOffset(triggerRect.left, nearestRect.left, scrollLeft) - containerRect.width;
      if (arrowRect) resultLeft -= arrowRect.height < arrowRect.width ? arrowRect.height : arrowRect.width;
      if (typeof options.offset !== 'undefined') resultLeft -= options.offset;
      break;

    case 'right':
      resultTop = getStartingOffset(triggerRect.top, nearestRect.top, scrollTop, nearestPositionedElement);
      resultLeft = getStartingOffset(triggerRect.left, nearestRect.left, scrollLeft) + triggerRect.width;
      if (arrowRect) resultLeft += arrowRect.height < arrowRect.width ? arrowRect.height : arrowRect.width;
      if (typeof options.offset !== 'undefined') resultLeft += options.offset;
      break;

    default:
      return invalidSpecs;
  }

  return {
    top: Math.round(resultTop),
    left: Math.round(resultLeft),
    placement: placement,
    invalid: false
  };
}

function getValidPlacement(startingTop, startingLeft, heightToCheck, widthToCheck, placement, triggerRect, containerRect, options, arrowRect) {
  var placementIsValid = false;
  var placementHistory = [];
  var checkTop;
  var checkLeft;

  while (!placementIsValid) {
    checkTop = startingTop;
    checkLeft = startingLeft;

    if (!areRemainingPlacements(placementHistory)) {
      return false;
    }

    switch (placement) {
      case 'top':
        checkTop -= containerRect.height;
        if (arrowRect) checkTop -= arrowRect.height;
        if (typeof options.offset !== 'undefined') checkTop -= options.offset;
        checkLeft += triggerRect.width - containerRect.width;

        if (checkTop > 0 && checkLeft > 0) {
          placementIsValid = true;
        } else if (placementHistory.indexOf('bottom') < 0) {
          placement = 'bottom';
        } else {
          placement = 'right';
        }

        placementHistory.push('top');
        break;

      case 'bottom':
        checkTop += triggerRect.height;
        if (arrowRect) checkTop += arrowRect.height;
        if (typeof options.offset !== 'undefined') checkTop += options.offset;
        checkLeft += triggerRect.width - containerRect.width;

        if (heightToCheck > checkTop + containerRect.height && checkLeft > 0) {
          placementIsValid = true;
        } else if (placementHistory.indexOf('top') < 0) {
          placement = 'top';
        } else {
          placement = 'right';
        }

        placementHistory.push('bottom');
        break;

      case 'left':
        checkLeft -= containerRect.width;
        if (arrowRect) checkLeft -= arrowRect.width;
        if (typeof options.offset !== 'undefined') checkLeft -= options.offset;

        if (checkLeft > 0 && heightToCheck > checkTop + containerRect.height) {
          placementIsValid = true;
        } else if (placementHistory.indexOf('right') < 0) {
          placement = 'right';
        } else {
          placement = 'top';
        }

        placementHistory.push('left');
        break;

      case 'right':
        checkLeft += triggerRect.width;
        if (arrowRect) checkLeft += arrowRect.width;
        if (typeof options.offset !== 'undefined') checkLeft += options.offset;

        if (widthToCheck > checkLeft + containerRect.width && heightToCheck > checkTop + containerRect.height) {
          placementIsValid = true;
        } else if (placementHistory.indexOf('left') < 0) {
          placement = 'left';
        } else {
          placement = 'top';
        }

        placementHistory.push('right');
        break;

      default:
        return false;
    }
  }

  return placement;
} // Determines the position for listDropdown, while finding a valid placement and checking if there is space to place the listDropdown


function getSpecs(listDropdownTrigger, listDropdownContainer, placement, options) {
  if (options === void 0) {
    options = {};
  }

  if (!listDropdownTrigger || !listDropdownContainer || listDropdownTrigger.getBoundingClientRect === undefined || listDropdownContainer.getBoundingClientRect === undefined) {
    return invalidSpecs;
  }

  var triggerRect = listDropdownTrigger.getBoundingClientRect();
  var containerRect = listDropdownContainer.getBoundingClientRect();
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var _document = document,
      body = _document.body;
  var html = document.documentElement;
  var pageHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.offsetHeight);
  var pageWidth = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.offsetWidth);
  var arrowRect;
  if (options.arrow) arrowRect = options.arrow.getBoundingClientRect(); // Check if a valid placement that fits in the current window the page exists

  var validPlacement = getValidPlacement(triggerRect.top, triggerRect.left, window.innerHeight, window.innerWidth, placement, triggerRect, containerRect, options, arrowRect); // If no valid placement fits in the current window, check if there exists a valid placement on the page (i.e. will not be fully visible in the window, but will fit on the page)

  if (!validPlacement) {
    validPlacement = getValidPlacement(triggerRect.top + scrollTop, triggerRect.left + scrollLeft, pageHeight, pageWidth, placement, triggerRect, containerRect, options, arrowRect); // If no room on the page to fit, then return as invalid

    if (!validPlacement) return invalidSpecs;
  }

  return getResultSpecs(validPlacement, listDropdownTrigger, triggerRect, containerRect, scrollTop, scrollLeft, options);
}

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(337);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-dropdown__wrapper{display:inline-block;position:relative;max-width:100%}.ba-common-dropdown{position:fixed;white-space:nowrap;text-align:left;overflow-x:hidden;overflow-y:auto;z-index:9001}.ba-common-dropdown.is-truncated{width:100%}.ba-common-dropdown__menuItem{height:40px}.ba-common-dropdown__menuItem.is-focus{outline-offset:-2px;margin:0}[dir=\"ltr\"].ba-common-dropdown__menuItem{text-align:left}[dir=\"rtl\"].ba-common-dropdown__menuItem{text-align:right}[dir=\"ltr\"] .ba-common-dropdown__menuItem,.ba-common-dropdown__menuItem{text-align:left}[dir=\"rtl\"] .ba-common-dropdown__menuItem{text-align:right}.ba-common-dropdown.is-grouped .ba-common-dropdown__groupLabel{margin-left:16px;margin-top:8px}.ba-common-dropdown.is-grouped .ba-common-dropdown__menuItemInner{padding-left:16px}.ba-common-dropdown .ba-common-list .ba-common-label{color:#343334;cursor:default}.ba-common-dropdown.is-small .ba-common-dropdown__menuItem{height:32px}.ba-common-dropdown{color:#eaeaea;background-color:#fff;font-size:.875rem}@media screen and (-ms-high-contrast: active){.ba-common-dropdown{border:1px solid #fff}}.ba-common-dropdown[aria-expanded=\"true\"]{box-shadow:0 2px 8px 0 rgba(0,0,0,0.1)}.ba-common-dropdown[aria-expanded=\"true\"].is-above{box-shadow:0 -2px 8px 0 rgba(0,0,0,0.1)}.ba-common-dropdown__menuItem{color:#343334;font-weight:400}.ba-common-dropdown__menuItem .ba-common-truncatedText__text{line-height:1.25rem}\n", ""]);

// exports
exports.locals = {
	"dropdownClassName": "\"ba-common-dropdown\""
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__42__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(67);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-label{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px;display:inline-block;margin:0;user-select:none;cursor:default}.ba-common-label.is-disabled{cursor:not-allowed}.ba-common-label.is-disabled .ba-common-truncatedText{cursor:inherit}.ba--highContrast .ba-common-label.is-disabled{cursor:not-allowed;text-decoration:line-through}.ba-common-label{transition:opacity .2s ease-in-out;color:#161616}.ba-common-label.is-disabled{color:#c6c6c6}\n", ""]);

// exports
exports.locals = {
	"labelClassName": "\"ba-common-label\""
};

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[332,0]]]);
});